import axiosSetup from "../utils/axiosSetup";

export interface LossReportRequest {
  startMonth: number;
  startYear: number;
  endMonth: number;
  endYear: number;
}

export interface LossReportResponse {
  success: boolean;
  data: any[];
  message?: string;
}

export const fetchMonthlyLossReportApi = async (
  data: LossReportRequest,
): Promise<LossReportResponse> => {
  try {
    const res = await axiosSetup.post("/shrink-loss/monthly-report", data);
    return res.data;
  } catch (error) {
    throw error;
  }
};
